import { render, staticRenderFns } from "./FloorAreaOffice.vue?vue&type=template&id=4f84c2d2&"
import script from "./FloorAreaOffice.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaOffice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports